module.exports = __webpack_public_path__ + "static/media/riskyActivityCheck.994c241a.mp3";